<template>
  <div>
    <div class="p-4">
      <p v-if="closestPlant">
        {{ dictionary.deliveryPostcode }} {{ currentPostcode }}
        <a href="#" v-on:click.prevent="closestPlant = null">
          {{ dictionary.editPostcode }}
        </a>
      </p>

      <postcode-picker
        v-else
        :saving="savingPostcode"
        :currentPostcode="currentPostcode"
        v-on:save="savePostcode"
      ></postcode-picker>

      <div class="mt-5" v-if="closestPlant">
          <span class="badge bg-primary text-light p-2">Steg 2</span>

          <h5 class="mb-3 mt-4">{{ dictionary.areaToCover }}</h5>
          <div class="form-row">
              <div class="form-group col-12 col-lg-3">
                  <label for="length">{{ dictionary.length }}</label>
                  <div class="input-group">
                      <input type="number"
                             class="form-control"
                             id="length"
                             min="0"
                             v-model="length"
                             v-on:input="calculateVolume" />
                      <div class="input-group-append">
                          <span class="input-group-text">m</span>
                      </div>
                  </div>
              </div>

              <div class="form-group col-12 col-lg-3">
                  <label for="width">{{ dictionary.width }}</label>
                  <div class="input-group">
                      <input type="number"
                             class="form-control"
                             id="width"
                             min="0"
                             v-model="width"
                             v-on:input="calculateVolume" />
                      <div class="input-group-append">
                          <span class="input-group-text">m</span>
                      </div>
                  </div>
              </div>

              <div class="form-group col-12 col-lg-3">
                  <label for="depth">{{ dictionary.depth }}</label>
                  <div class="input-group">
                      <input type="number"
                             class="form-control"
                             id="depth"
                             min="0"
                             v-model="depth"
                             v-on:input="calculateVolume" />
                      <div class="input-group-append">
                          <span class="input-group-text">cm</span>
                      </div>
                  </div>
              </div>

              <div class="form-group col-12 col-lg-3 align-self-end text-right">
                  <button class="btn"
                          :class="enableButton ? 'btn-secondary' : 'btn-outline-light'"
                          :disabled="!enableButton"
                          type="button"
                          v-on:click="commitMass">
                      {{ dictionary.calculateQuantity }}
                  </button>
              </div>
          </div>

          <div v-if="committedMass > 0">
              <h5 class="mt-3 mb-4">{{ dictionary.chooseDeliveryMethod }}</h5>
              <quantity-field-collection :variants="productVariants"
                                         :quantity="committedMass"
                                         :closest-plant="closestPlant"></quantity-field-collection>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import log from "loglevel";
import LocationService from "../services/location.service";
import { GetTranslations } from "../services/translation.service";
import QuantityFieldCollection from "./quantity-field-collection.vue";
import PostcodePicker from "./postcode-picker.vue";

export default {
  name: "MassCalculator",
  props: {
    variants: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      length: 0,
      width: 0,
      depth: 0,
      volume: 0,
      mass: 0,
      committedMass: 0,
      closestPlant: null,
      savingPostcode: false,
      currentPostcode: LocationService.GetPostcode(),
      productVariants: [...this.variants],
      dictionary: GetTranslations("massCalculator"),
    };
  },
  computed: {
    enableButton: function () {
      return this.volume > 0 && this.mass !== this.committedMass;
    },
  },
  methods: {
    getCrushingFactor: function () {
      return this.productVariants[0].crushingFactors[
        this.closestPlant.plant.id
      ];
    },
    calculateVolume: function () {
      let { length, width, depth } = this;
      if (length && width && depth) {
        let volume = (this.volume = length * width * (depth / 100));
        log.info("Calculated volume", { length, width, depth, volume });
        let crushingFactor = this.getCrushingFactor();
        let mass = (this.mass = crushingFactor * volume);
        log.info("Calculated mass", { crushingFactor, mass });
      }
    },
    commitMass: function () {
      this.committedMass = this.mass;
    },
    savePostcode: function (postcode) {
      var me = this;
      me.savingPostcode = true;
      LocationService.SavePostcode(postcode);
      me.currentPostcode = postcode;
      LocationService.GetClosestCrushingPlant(
        // N.B. this only works because both variants come from the same place.
        me.productVariants[0].productReference
      ).then((closestPlant) => {
        me.closestPlant = closestPlant;
        me.savingPostcode = false;
      });
    },
  },
  mounted() {
    var me = this;
    if (me.currentPostcode) {
      LocationService.GetClosestCrushingPlant(
        me.productVariants[0].productReference
      ).then((plant) => {
        me.closestPlant = plant;
      });
    }
  },
  components: {
    QuantityFieldCollection,
    PostcodePicker,
  },
};
</script>